import * as React from 'react';
import { BloodGlucoseQueryTable } from './BloodGlucoseQueryTable';
import DocumentTitle from '../misc/components/DocumentTitle';
import { ODataParams, Query } from '../Components/Query';
import { useWebPortalApiClient } from '../misc/api/WebPortalTokenClient';
import { useCurrentStudyConfigurationContext } from '../Core/CurrentStudyConfigurationContext';
import { QueryOfBloodGlucoseSession } from 'webportalclient';

export const BloodGlucoseListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams): Promise<QueryOfBloodGlucoseSession> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `visit/subject/site/studyId eq ${study.id}`;
        return await client.client.getBloodGlucoseSessions(undefined, filter, params.orderby, 'visit($expand=subject($expand=site($select=number,studyId)))', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Blood Glucose Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <BloodGlucoseQueryTable />
            </Query>
        </DocumentTitle>
    );
};
